import withStore, { TLoadingAwarePresenter, TPresentable } from "../withStore";
import Application from "../../Application";
import ShowErrorMessageInteractor from "../../interactor/notifications/ShowErrorMessageInteractor";
import { IRequest } from "../../model/request/Request";
import GetRequestsInteractor from "../../interactor/requests/GetRequestsInteractor";
import MarkRequestReadInteractor from "../../interactor/requests/MarkRequestReadInteractor";

export interface TRequestsPresenter extends TLoadingAwarePresenter {
  requests: IRequest[];
  requestsDetailsDialogVisible?: boolean;
  rowData?: any;
}
export interface IRequestsPresenter extends TRequestsPresenter, TPresentable {
  getRequests(applicantId: number): Promise<void>;
  setRequests(requests: IRequest[]): void;
  markRequestRead(request: IRequest): void;
  showRequestsDetailsDialog(): void;
  hideRequestsDetailsDialog(): void;
  setRowData(rowData: any): void;
}

const defaultState: TRequestsPresenter = {
  requests: []
};

const RequestsPresenter = withStore<IRequestsPresenter, TRequestsPresenter>(
  ({ application, store, loader, translate }): IRequestsPresenter => {
    const _store = store;
    const _application: Application = application;
    const state = _store.getState<TRequestsPresenter>();

    loader.start("requestsLoader");

    const setRequests = (requests: IRequest[]) => {
      _store.update({ requests });
      loader.stop("requestsLoader");
    };

    const getRequests = async () => {
      try {
        let requests = await _application.container
          .resolve<GetRequestsInteractor>("getRequests")
          .execute();
        _store.update({ requests });
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const markRequestRead = async (request: IRequest) => {
      try {
        await _application.container
          .resolve<MarkRequestReadInteractor>("markRequestRead")
          .execute(request);
      } catch (error) {
        _application.container
          .resolve<ShowErrorMessageInteractor>("showErrorMessage")
          .execute((error as any).message);
      }
    };

    const setRowData = (rowData: any) => {
      _store.update({ rowData });
    };

    const showRequestsDetailsDialog = () => {
      _store.update({ requestsDetailsDialogVisible: true });
    };

    const hideRequestsDetailsDialog = () => {
      getRequests();
      _store.update({ requestsDetailsDialogVisible: false });
    };

    return {
      ...state,

      store: _store,
      loader,
      application: _application,
      translate,
      getRequests,
      setRequests,
      markRequestRead,
      setRowData,
      showRequestsDetailsDialog,
      hideRequestsDetailsDialog
    };
  },
  defaultState
);

export default RequestsPresenter;
